<script setup lang="ts">
defineOptions({
  name: 'CertificateLayout',
});
</script>

<template>
  <div class="min-h-screen bg-white">
    <slot />
  </div>
</template>
